import React, { Component } from "react";

export default class Section extends Component {
  render() {
    const { children, white, className = "" } = this.props;
    let _classNames = ["wrapper"];
    if (white) {
      _classNames.push("wrapper-white");
    }
    return (
      <div className={_classNames.concat(className.split(",")).join(" ")}>
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/UI/Section/index.js